const data = {
  counterText: 'పరిమిత స్లాట్‌లు అందుబాటులో ఉన్నాయి',
  loading: 'లోడ్ అవుతోంది',
  next: 'తరువాత',
  previous: 'ముందు',
  smCounterText: 'పరిమిత స్లాట్లు అందుబాటులో ఉన్నాయి',
};

export default data;
